export interface PasTraseu {
  cand: string | Date
  titlu: string
  loc?: string | null
}

const cand = (d: string | Date) =>
  new Date(d).toLocaleString('ro-RO', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })

/**
 * Drumul unui lucru prin starile lui — coletul prin depozitele curierului, mai tarziu si comanda
 * sau task-ul. Primul pas e albastru, ultimul galben (unde e acum), restul gri.
 */
export function Traseu({ pasi, gol }: { pasi: PasTraseu[]; gol?: string }) {
  if (pasi.length === 0)
    return <p className="text-sm text-b4l-text-muted">{gol ?? 'Nimic încă.'}</p>
  return (
    <ol className="grid">
      {pasi.map((p, i) => {
        const primul = i === 0
        const ultimul = i === pasi.length - 1
        return (
          <li
            key={`${i}-${p.titlu}`}
            className="relative grid grid-cols-[14px_minmax(0,1fr)] gap-2.5 pb-3"
          >
            <span
              className={`mt-1 h-[9px] w-[9px] rounded-full ${
                ultimul ? 'bg-b4l-amber' : primul ? 'bg-b4l-blue' : 'bg-b4l-text-dim'
              }`}
            />
            {!ultimul && (
              <span className="absolute bottom-0 left-1 top-[15px] w-px bg-b4l-border" />
            )}
            <div className="min-w-0">
              <div className="text-sm">{p.titlu}</div>
              <div className="text-xs text-b4l-text-dim">
                {cand(p.cand)}
                {p.loc ? ` · ${p.loc}` : ''}
              </div>
            </div>
          </li>
        )
      })}
    </ol>
  )
}
